import components from './components.js';
import errors from './errors';
import faqs from './faqs';
import paymentNetworks from './paymentNetworks/index';
import byLanguageCode from './byLanguageCode';
import i18n from './i18n';

/* eslint no-template-curly-in-string: "off" */
// TODO: handle custom css styles in config
// TODO: create config.js file
// TODO: allow program configuration of timeout intervals
const config = {
  document: {
    title: "",
    favicon: null
  },
  stylesheets: [],
  styles: {
    title: {},
    description: {},
    secondaryText: {},
    paymentAmount: {},
    date: {},
    recipientEmail: {},
    networkDisplayName: {}
  },
  faqs,
  ...components,
  errors,
  paymentNetworks,
  byLanguageCode,
  i18n,
};

export default config;
